/* eslint-disable no-console */
'use client';

import React, { Component, ErrorInfo, ReactNode } from 'react';

type Props = {
  children: ReactNode;
};

type State = {
  hasError: boolean;
};

class ErrorBoundary extends Component<Props, State> {
  state: State = {
    hasError: false,
  };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
  }

  handleRefresh() {
    window.location.reload();
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className='min-h-screen flex flex-col items-center justify-center p-8 text-center'>
          <h1 className='text-2xl font-bold text-red-600'>
            Something went wrong
          </h1>
          <p className='mt-2 text-gray-500'>
            Try refreshing or contact support.
          </p>
          <button
            onClick={this.handleRefresh}
            className='mt-2 text-blue-700 font-bold cursor-pointer hover:underline'
          >
            Refresh Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
